<template>
	<ux-panel>
		<ux-panel-title>
			<div class="text-caption">Order Items</div>
		</ux-panel-title>

		<table class="ux-table" cellpadding="0" cellspacing="0" border="0">
			<thead>
				<tr>
					<th style="width:100px;">Qty</th>
					<th>Description</th>
					<th>Amount</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="line in order.lines" :key="line.id">
					<td>{{ line.quantity }}</td>
					<td class="preserve-line-breaks">{{ line.description }}</td>
					<td>{{ line.amount | currency }}</td>
				</tr>

				<tr>
					<td colspan="2" class="text-align-right font-weight-600">Subtotal:</td>
					<td>{{ order.subtotal | currency }}</td>
				</tr>

				<template v-if="order.coupons.length > 0">
					<tr v-for="coupon in order.coupons" :key="coupon.id">
						<td colspan="2" class="text-align-right font-weight-600">{{ `${coupon.name} (${coupon.code})` }}:</td>
						<td>{{ coupon.deduct }}</td>
					</tr>
					<tr>
						<td colspan="2" class="text-align-right font-weight-600">After discount:</td>
						<td>{{ order.discounted_subtotal | currency }}</td>
					</tr>
				</template>

				<tr v-for="tax in order.taxes" :key="tax.id">
					<td colspan="2" class="text-align-right font-weight-600">{{ tax.name }}:</td>
					<td>{{ tax.amount | currency }}</td>
				</tr>

				<tr>
					<td colspan="2" class="text-align-right font-weight-600">Total:</td>
					<td>{{ order.total | currency }}</td>
				</tr>
			</tbody>
		</table>
	</ux-panel>
</template>

<script>
import { mapState } from 'vuex';

import filters from 'common/filters';

import OrderDetailLine from './OrderDetailLine.vue';

export default {
	components: { OrderDetailLine },
	mixins: [filters],

	computed: {
		...mapState({
			order: state => state.profile.currentOrder,
		}),
	},
}
</script>